export class EnvironmentFactorModel {
    constructor(public instanceId?: number,
                public trialInstance?: number,
                public idValueMap?: any
    ) {
    }
}
